import { render, staticRenderFns } from "./FreightReview.vue?vue&type=template&id=79616b24&scoped=true&"
import script from "./FreightReview.vue?vue&type=script&lang=js&"
export * from "./FreightReview.vue?vue&type=script&lang=js&"
import style0 from "./FreightReview.vue?vue&type=style&index=0&id=79616b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79616b24",
  null
  
)

export default component.exports